import React from 'react'
import cn from 'classnames'
import styles from 'components/shared/icons/icons.module.scss'

interface HodlockerIconProps {
    contextStyles?: string
    hoverStyles?: string
    selectedStyles?: string
    initialStyles?: string
}

export default function HodlockerIcon({
    contextStyles,
    hoverStyles,
    selectedStyles,
    initialStyles,
}: HodlockerIconProps) {
    return (
        <div className={cn(contextStyles, hoverStyles, selectedStyles, styles.hodlockerIcon)}>
            <div className={initialStyles}>HL</div>
        </div>
    )
}
